// Automatically generated
export const LINK_KEYS = ["isExternal"] as const;
